import axios from 'axios';

export const getApiUrl = () => {
  // Priorité 1: Configuration runtime (pour Azure)
  if (typeof window !== 'undefined' && (window as any).APP_CONFIG?.VITE_API_URL) {
    return (window as any).APP_CONFIG.VITE_API_URL;
  }
  
  // Priorité 2: Variable d'environnement Vite (pour le développement)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // Valeur par défaut
  return 'http://localhost:4999/api';
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api; 